import { createFileRoute } from '@tanstack/react-router'
import { requirePermission } from '../../../app/guards'
import { workflowSearchSchema } from '../../../features/workflows/search'
import { WorkflowsListPage } from '../../../features/workflows/workflows-list-page'

export const Route = createFileRoute('/_app/workflows/')({
  validateSearch: workflowSearchSchema,
  beforeLoad: ({ context }) => requirePermission(context.session, 'workflows.read'),
  component: WorkflowsListPage,
})
